function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13 13v5.7c1.4-2.5 4-4.4 7-4.7-.4 4.2-3.8 7.6-8 8-4.2-.4-7.6-3.8-8-8 3 .3 5.6 2.2 7 4.7V13c-2.3-.6-4-2.6-4-5h4.2H7V4c0-.6.3-.7.6-.2l2 2.2 1.8-2.2c.3-.5 1-.5 1.2 0l2 2.2 1.8-2.2c.3-.5.6-.4.6.2v4h-4 4c0 2.4-1.7 4.4-4 5z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgLocationGarden(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGarden);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0xMyAxM3Y1LjdjMS40LTIuNSA0LTQuNCA3LTQuNy0uNCA0LjItMy44IDcuNi04IDgtNC4yLS40LTcuNi0zLjgtOC04IDMgLjMgNS42IDIuMiA3IDQuN1YxM2MtMi4zLS42LTQtMi42LTQtNWg0LjJIN1Y0YzAtLjYuMy0uNy42LS4ybDIgMi4yIDEuOC0yLjJjLjMtLjUgMS0uNSAxLjIgMGwyIDIuMiAxLjgtMi4yYy4zLS41LjYtLjQuNi4ydjRoLTQgNGMwIDIuNC0xLjcgNC40LTQgNXoiLz48L2c+PC9nPjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };